import ContentFetch from "./ContentFetch"
import { ContentFetchProps } from "./interface"

export type { ContentFetchProps }
export default ContentFetch
